import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoAplicacaoModel } from './model-consultaSeguimento'
import { ConsultaSeguimentoPergunta01Field } from './perguntas/consulta-seguimento-pergunta-01/ConsultaSeguimentoPergunta01Field'
import { convertConsultaSeguimentoPergunta01ToInput } from './perguntas/consulta-seguimento-pergunta-01/convert-consultaSeguimentoPergunta01'
import { ConsultaSeguimentoPergunta01Model } from './perguntas/consulta-seguimento-pergunta-01/model-consultaSeguimentoPergunta01'
import { ConsultaSeguimentoPergunta02Field } from './perguntas/consulta-seguimento-pergunta-02/ConsultaSeguimentoPergunta02Field'
import { convertConsultaSeguimentoPergunta02ToInput } from './perguntas/consulta-seguimento-pergunta-02/convert-consultaSeguimentoPergunta02'
import { ConsultaSeguimentoPergunta03Field } from './perguntas/consulta-seguimento-pergunta-03/ConsultaSeguimentoPergunta03Field'
import { convertConsultaSeguimentoPergunta03ToInput } from './perguntas/consulta-seguimento-pergunta-03/convert-consultaSeguimentoPergunta03'
import { ConsultaSeguimentoPergunta04Field } from './perguntas/consulta-seguimento-pergunta-04/ConsultaSeguimentoPergunta04Field'
import { convertConsultaSeguimentoPergunta04ToInput } from './perguntas/consulta-seguimento-pergunta-04/convert-consultaSeguimentoPergunta04'
import { ConsultaSeguimentoPergunta05Field } from './perguntas/consulta-seguimento-pergunta-05/ConsultaSeguimentoPergunta05Field'
import { convertConsultaSeguimentoPergunta05ToInput } from './perguntas/consulta-seguimento-pergunta-05/convert-consultaSeguimentoPergunta05'
import { ConsultaSeguimentoPergunta06Field } from './perguntas/consulta-seguimento-pergunta-06/ConsultaSeguimentoPergunta06Field'
import { convertConsultaSeguimentoPergunta06ToInput } from './perguntas/consulta-seguimento-pergunta-06/convert-consultaSeguimentoPergunta06'
import { ConsultaSeguimentoPergunta07Field } from './perguntas/consulta-seguimento-pergunta-07/ConsultaSeguimentoPergunta07Field'
import { convertConsultaSeguimentoPergunta07ToInput } from './perguntas/consulta-seguimento-pergunta-07/convert-consultaSeguimentoPergunta07'
import { ConsultaSeguimentoPergunta08Field } from './perguntas/consulta-seguimento-pergunta-08/ConsultaSeguimentoPergunta08Field'
import { convertConsultaSeguimentoPergunta08ToInput } from './perguntas/consulta-seguimento-pergunta-08/convert-consultaSeguimentoPergunta08'
import { ConsultaSeguimentoPergunta09Field } from './perguntas/consulta-seguimento-pergunta-09/ConsultaSeguimentoPergunta09Field'
import { convertConsultaSeguimentoPergunta09ToInput } from './perguntas/consulta-seguimento-pergunta-09/convert-consultaSeguimentoPergunta09'
import { ConsultaSeguimentoPergunta10Field } from './perguntas/consulta-seguimento-pergunta-10/ConsultaSeguimentoPergunta10Field'
import { convertConsultaSeguimentoPergunta10ToInput } from './perguntas/consulta-seguimento-pergunta-10/convert-consultaSeguimentoPergunta10'
import { ConsultaSeguimentoPergunta11Field } from './perguntas/consulta-seguimento-pergunta-11/ConsultaSeguimentoPergunta11Field'
import { convertConsultaSeguimentoPergunta11ToInput } from './perguntas/consulta-seguimento-pergunta-11/convert-consultaSeguimentoPergunta11'
import { ConsultaSeguimentoPergunta12Field } from './perguntas/consulta-seguimento-pergunta-12/ConsultaSeguimentoPergunta12Field'
import { convertConsultaSeguimentoPergunta12ToInput } from './perguntas/consulta-seguimento-pergunta-12/convert-consultaSeguimentoPergunta12'
import { ConsultaSeguimentoPergunta13Field } from './perguntas/consulta-seguimento-pergunta-13/ConsultaSeguimentoPergunta13Field'
import { convertConsultaSeguimentoPergunta13ToInput } from './perguntas/consulta-seguimento-pergunta-13/convert-consultaSeguimentoPergunta13'
import { ConsultaSeguimentoPergunta14Field } from './perguntas/consulta-seguimento-pergunta-14/ConsultaSeguimentoPergunta14Field'
import { convertConsultaSeguimentoPergunta14ToInput } from './perguntas/consulta-seguimento-pergunta-14/convert-consultaSeguimentoPergunta14'
import { ConsultaSeguimentoPergunta15Field } from './perguntas/consulta-seguimento-pergunta-15/ConsultaSeguimentoPergunta15Field'
import { convertConsultaSeguimentoPergunta15ToInput } from './perguntas/consulta-seguimento-pergunta-15/convert-consultaSeguimentoPergunta15'
import { ConsultaSeguimentoPergunta16Field } from './perguntas/consulta-seguimento-pergunta-16/ConsultaSeguimentoPergunta16Field'
import { convertConsultaSeguimentoPergunta16ToInput } from './perguntas/consulta-seguimento-pergunta-16/convert-consultaSeguimentoPergunta16'
import { ConsultaSeguimentoPergunta17Field } from './perguntas/consulta-seguimento-pergunta-17/ConsultaSeguimentoPergunta17Field'
import { convertConsultaSeguimentoPergunta17ToInput } from './perguntas/consulta-seguimento-pergunta-17/convert-consultaSeguimentoPergunta17'
import { ConsultaSeguimentoPergunta18Field } from './perguntas/consulta-seguimento-pergunta-18/ConsultaSeguimentoPergunta18Field'
import { convertConsultaSeguimentoPergunta18ToInput } from './perguntas/consulta-seguimento-pergunta-18/convert-consultaSeguimentoPergunta18'
import { ConsultaSeguimentoPergunta19Field } from './perguntas/consulta-seguimento-pergunta-19/ConsultaSeguimentoPergunta19Field'
import { convertConsultaSeguimentoPergunta19ToInput } from './perguntas/consulta-seguimento-pergunta-19/convert-consultaSeguimentoPergunta19'

type ConsultaSeguimentoPerguntasMapModel = {
  [Key in keyof ConsultaSeguimentoAplicacaoModel]: {
    Field: React.ComponentType<{
      name: MetaPath<ConsultaSeguimentoAplicacaoModel[Key]>
      perguntasSelecionadas: MChatPerguntaEnum[]
    }>
    convertToInput: (resposta: ConsultaSeguimentoAplicacaoModel[Key]) => MChatRfPerguntaRespostaInput[]
  }
}

export const ConsultaSeguimentoPerguntasMap: ConsultaSeguimentoPerguntasMapModel = {
  PERGUNTA_01: {
    Field: ConsultaSeguimentoPergunta01Field,
    convertToInput: convertConsultaSeguimentoPergunta01ToInput,
  },
  PERGUNTA_02: {
    Field: ConsultaSeguimentoPergunta02Field,
    convertToInput: convertConsultaSeguimentoPergunta02ToInput,
  },
  PERGUNTA_03: {
    Field: ConsultaSeguimentoPergunta03Field,
    convertToInput: convertConsultaSeguimentoPergunta03ToInput,
  },
  PERGUNTA_04: {
    Field: ConsultaSeguimentoPergunta04Field,
    convertToInput: convertConsultaSeguimentoPergunta04ToInput,
  },
  PERGUNTA_05: {
    Field: ConsultaSeguimentoPergunta05Field,
    convertToInput: convertConsultaSeguimentoPergunta05ToInput,
  },
  PERGUNTA_06: {
    Field: ConsultaSeguimentoPergunta06Field,
    convertToInput: convertConsultaSeguimentoPergunta06ToInput,
  },
  PERGUNTA_07: {
    Field: ConsultaSeguimentoPergunta07Field,
    convertToInput: convertConsultaSeguimentoPergunta07ToInput,
  },
  PERGUNTA_08: {
    Field: ConsultaSeguimentoPergunta08Field,
    convertToInput: convertConsultaSeguimentoPergunta08ToInput,
  },
  PERGUNTA_09: {
    Field: ConsultaSeguimentoPergunta09Field,
    convertToInput: convertConsultaSeguimentoPergunta09ToInput,
  },
  PERGUNTA_10: {
    Field: ConsultaSeguimentoPergunta10Field,
    convertToInput: convertConsultaSeguimentoPergunta10ToInput,
  },
  PERGUNTA_11: {
    Field: ConsultaSeguimentoPergunta11Field,
    convertToInput: convertConsultaSeguimentoPergunta11ToInput,
  },
  PERGUNTA_12: {
    Field: ConsultaSeguimentoPergunta12Field,
    convertToInput: convertConsultaSeguimentoPergunta12ToInput,
  },
  PERGUNTA_13: {
    Field: ConsultaSeguimentoPergunta13Field,
    convertToInput: convertConsultaSeguimentoPergunta13ToInput,
  },
  PERGUNTA_14: {
    Field: ConsultaSeguimentoPergunta14Field,
    convertToInput: convertConsultaSeguimentoPergunta14ToInput,
  },
  PERGUNTA_15: {
    Field: ConsultaSeguimentoPergunta15Field,
    convertToInput: convertConsultaSeguimentoPergunta15ToInput,
  },
  PERGUNTA_16: {
    Field: ConsultaSeguimentoPergunta16Field,
    convertToInput: convertConsultaSeguimentoPergunta16ToInput,
  },
  PERGUNTA_17: {
    Field: ConsultaSeguimentoPergunta17Field,
    convertToInput: convertConsultaSeguimentoPergunta17ToInput,
  },
  PERGUNTA_18: {
    Field: ConsultaSeguimentoPergunta18Field,
    convertToInput: convertConsultaSeguimentoPergunta18ToInput,
  },
  PERGUNTA_19: {
    Field: ConsultaSeguimentoPergunta19Field,
    convertToInput: convertConsultaSeguimentoPergunta19ToInput,
  },
  PERGUNTA_20: {
    Field: () => <div />,
    convertToInput: (value: ConsultaSeguimentoPergunta01Model): MChatRfPerguntaRespostaInput[] => {
      return [
        {
          pergunta: MChatPerguntaEnum.PERGUNTA_20_01,
          stResposta: true,
        },
      ]
    },
  },
}
